import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04d0af3f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title text-center p-t-20 p-b-20" }, "账号升级问卷问题", -1))
const _hoisted_2 = { class: "p-l-40 p-r-40" }
const _hoisted_3 = { class: "text-center p-t-10 p-b-20 full-width" }

import { onMounted, ref, reactive,computed, nextTick } from 'vue';  
import { ElMessage, ElMessageBox } from "element-plus";
import { 
  getSurveyTemplate,
  saveVisitorData
} from "@/api/request/user";
import LockDialog from '@/components/LockDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VisitorSurvey',
  props: {
  callback: {
    type: Function,
    required: false
  }
},
  setup(__props) {

const $props = __props;




const show = ref(true);
const title = ref('');
const saveloading = ref(false);
const surveyData = ref([]);

const rules = computed(() => {
  const r: any = {};
  surveyData.value.forEach((item, index) => {
    const trigger = item.type === 'select' ? 'change' : 'blur';
    r[`${index}.value`] = [
      { required: true, message: `字段不能为空`, trigger }
    ];
  });
  return r;
});

const form = ref()    
const submitForm = () => {
  form.value.validate((valid: boolean) => {
    if (valid) {
        saveloading.value = true; 
       saveVisitorData({ surveyJson: surveyData.value }).then(({ code }) => {
            if (code === '00') { 
                saveloading.value = false;
                ElMessage.success('提交成功');

                $props.callback && $props.callback();

                show.value = false;
            }
        }).catch(() => {
            saveloading.value = false;
        });    
    }
  });
};

onMounted(() => {
   

  getSurveyTemplate().then(({code,data}) => { 
    if(code === '00'){
        title.value = data.surveyTitle;
 
        surveyData.value = JSON.parse(data.surveyJson);
         
    }

  });
});
const lockDialog = ref();
const openedFun = () => {
  console.log('Dialog opened');
  nextTick(() => {
    if (lockDialog.value) {
      lockDialog.value.lock();
    }
   }); 
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(LockDialog, {
    ref_key: "lockDialog",
    ref: lockDialog
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_dialog, {
        modelValue: show.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
        onOpened: openedFun,
        title: "问卷调查",
        width: "100%",
        "show-close": false,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_form, {
              ref_key: "form",
              ref: form,
              model: surveyData.value,
              rules: _unref(rules),
              "label-width": "auto"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(surveyData.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_form_item, {
                    class: "m-b-30",
                    key: index,
                    prop: `${index}.value`
                  }, {
                    default: _withCtx(() => [
                      (item.type === 'text')
                        ? (_openBlock(), _createBlock(_component_el_input, {
                            key: 0,
                            size: "large",
                            modelValue: item.value,
                            "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                            maxlength: item.limit,
                            placeholder: `请输入${item.title}`,
                            "show-word-limit": ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "maxlength", "placeholder"]))
                        : (item.type === 'select')
                          ? (_openBlock(), _createBlock(_component_el_select, {
                              key: 1,
                              size: "large",
                              modelValue: item.value,
                              "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                              placeholder: `请选择${item.title}`
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.item, (option, optIndex) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: optIndex,
                                    label: option,
                                    value: option
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                          : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["prop"]))
                }), 128)),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_button, {
                        onClick: submitForm,
                        type: "primary",
                        size: "large",
                        round: "",
                        loading: saveloading.value,
                        color: "#fe2c55",
                        class: "min-width-200"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("提交")
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 512))
}
}

})